import { useState } from "react";
import { Box, TextField, Button } from "@mui/material";
import axios from 'axios';
import { URL, getRequestAccess, setDataInfo } from '../helper';

const stylesInput = {
  sx:{
    backgroundColor: '#8BAB89',
    color: 'white',
    borderRadius: '3px',
    width: '100%',
    padding: 0,
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: "#444444"
      }
    }
  },
  inputProps:{
    sx: {
      padding: '3px 10px',
      fontFamily: 'KIT65P',
      fontSize: '1.6rem',
      border: '1px solid #8BAB89',
      borderRadius: '10px',
    },
  }  
}

const init = {
  username: '',
  password: '',
}

export default function Login() {
  const [data, setData] = useState({ ...init });
  const [isInvalid, setIsInvalid] = useState(false);
  const [isError, setIsError] = useState(false);

  const onClickLogin = () => {
    if (!data.username || !data.password) {
      setIsInvalid(true);
    } else {
      setIsInvalid(false);

      const _data = {
        username: data.username,
        password: data.password,
        requestaccess: getRequestAccess(),
      }

      axios.post(URL.login, _data).then((res) => {
        if (res?.status === 200) {
          if (res?.data?.result === "complete") {
            const info = res?.data?.profileinfo;
            setDataInfo(info);
            window.location = '/';
          } else {
            setIsError(true);
          }
        } else {
          setIsError(true);
        }
      }).catch(error => {
        setIsError(true);
      });
    }
  }

  return (
    <div className="main">
      <Box sx={{ height: '100vh', background: '#D8F2DD', display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#444444', position: 'relative' }}>
        <Box className="login">
          <h1 style={{ textAlign: 'center' }}>ระบบจัดการคิว (แอดมิน)</h1>
          <Box sx={{ display: 'flex', alignItems: 'center', mt: 2.5 }}>
            <p className="login-label">Username</p>
            <TextField
              {...stylesInput}
              value={data.username}
              onChange={(e) => setData({
                ...data,
                username: e.target.value
              })}
            />
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
            <p className="login-label">Password</p>
            <TextField
              {...stylesInput}
              value={data.password}
              type="password"
              onChange={(e) => setData({
                ...data,
                password: e.target.value
              })}
            />
          </Box>
          {isInvalid && (
            <Box sx={{ mt: 2, mb: '-10px', textAlign: 'center' }}>
              <p style={{ color: 'red', fontSize: '24px' }}>Please enter Username and Password</p>
            </Box>
          )}
          {isError && (
            <Box sx={{ mt: 2, mb: '-10px', textAlign: 'center' }}>
              <p style={{ color: 'red', fontSize: '24px' }}>Login Failed</p>
            </Box>
          )}
          <Box sx={{ mt: 4, pb: 6, textAlign: 'center' }}>
            <Button
              style={{ 
                color: 'white',
                fontFamily: 'KIT65P',
                fontSize: '2.0rem',
                padding: '4px 40px',
                background: '#849880',
                borderRadius: '50px'
              }}
              onClick={onClickLogin}
            >
              เข้าสู่ระบบ
            </Button>
          </Box>
        </Box>

        <Box sx={{ position: 'absolute', bottom: 20 }}>
          <Box>
            <img src="/images/nose-tea.png" style={{ width: 'auto', height: 32 }} />
          </Box>
        </Box>
      </Box>
    </div>
  )
}